import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { isAxiosError } from 'axios';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (isAxiosError(err)) {
    const msg =
      err.response?.data?.message ??
      err.response?.data?.error ??
      err.message;
    if (msg && typeof msg === 'string') return msg;
  }
  if (err instanceof Error) return err.message;
  return fallback;
}
